import { TileLayer } from 'maptalks';

class BaseTileLayer extends TileLayer {
    // constructor(id, options) {
    //     super(id, options);
    // }
}

export default BaseTileLayer;
